export default __webpack_public_path__ + "static/media/H4001.16289183.mp3";